<template>
  <div class="fields flex grow">
    <EditableArea
      v-if="fields"
      class="grid gap-sm"
      :content="fields"
    />
  </div>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';

interface Props {
  fields?: any;
  horizontalPosition?: string;
  verticalPosition?: string;
  margin?: string;
  marginMobile?: string;
}

const props = withDefaults(defineProps<Props>(), {
  fields: undefined,
  horizontalPosition: 'center',
  verticalPosition: 'top',
  margin: '1.5',
  marginMobile: '1.5',
});
const numberOfColumns: number = inject('numberOfColumns', 0) ?? 0;

const padding = `${props.margin}rem`;
const paddingForMobile = `${props.marginMobile}rem`;
const flexBasis = `${80 / numberOfColumns}%`;
</script>

<style lang="scss" scoped>
.fields {
  text-align: v-bind(horizontalPosition);
  justify-content: v-bind(horizontalPosition);
  align-items: v-bind(verticalPosition);
  padding: v-bind(padding);
  flex-basis: v-bind(flexBasis);

  @include for-mobile {
    padding: v-bind(paddingForMobile);
  }

  @include only-mobile {
    flex-basis: unset;
  }
}
</style>
